import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'reportFormat' })
export class ReportFormatPipe implements PipeTransform {
  transform(str: string, type: string): string {
    const formats = ["0%", "0", "", 0];
    switch (type) {
      case 'value': return formats.indexOf(str) > -1 ? "0" :
        (Math.round(parseFloat(str))).toString();
      case 'currency': return formats.indexOf(str) > -1 ? "£0" :
        "£" + (Math.round(parseFloat(str))).toString();
      case 'dash': return formats.indexOf(str) > -1 ? "-" :
        (Math.round(parseFloat(str))).toString();
      case 'percentDash': return formats.indexOf(str) > -1 ? "-" :
        (Math.round(parseFloat(str) * 100)) + '%';
      case 'percentDashFull': return formats.indexOf(str) > -1 ? "100%" :
        (Math.round(parseFloat(str) * 100)) + '%';
      case 'percent': return formats.indexOf(str) > -1 ? "0%" :
        (Math.round(parseFloat(str) * 100)).toString() + '%';
      default: return (parseFloat(str)).toString();
    }
  }
}
